import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const LinkBox = styled(Link)`
  display: flex;
  flex: none;
  min-height: 0;
  min-width: 0;
  position: relative;
  color: inherit;
`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/ui/link-box.component.tsx